import styled from "styled-components";
import { colors, radius, spacing } from "design-system/foundation";
import { breakpoints } from "styles";

export const CropContainer = styled.div`
  &,
  & *,
  & *::before,
  & *::after {
    box-sizing: border-box;
  }

  width: calc(100% - ${spacing["4xl"]});
  margin: ${spacing.none} auto;

  @media ${breakpoints.tablet} {
    width: 100%;
    margin: ${spacing.none};
  }
`;

export const ImageArea = styled.div<{ $isCropMode: boolean }>`
  position: relative;
  width: 100%;
  aspect-ratio: 328 / 403;
  overflow: hidden;
  border-radius: ${radius.xl};
  background: #000;

  .cropper-container img {
    object-fit: ${({ $isCropMode }) =>
      $isCropMode ? "cover" : "contain"} !important;
  }

  @media ${breakpoints.tablet} {
    aspect-ratio: 752 / 462;
  }

  .cropper-view-box {
    outline: 0;
  }

  .cropper-line,
  .cropper-point.point-n,
  .cropper-point.point-e,
  .cropper-point.point-s,
  .cropper-point.point-w {
    display: none;
  }

  .cropper-point {
    width: 28px;
    height: 28px;
    background: transparent;
    opacity: 1;
  }

  .cropper-point.point-nw {
    top: -2px;
    left: -2px;
    border-top: 4px solid ${colors.bg.brand.primaryBold};
    border-left: 4px solid ${colors.bg.brand.primaryBold};
  }

  .cropper-point.point-ne {
    top: -2px;
    right: -2px;
    border-top: 4px solid ${colors.bg.brand.primaryBold};
    border-right: 4px solid ${colors.bg.brand.primaryBold};
  }

  .cropper-point.point-sw {
    bottom: -2px;
    left: -2px;
    border-bottom: 4px solid ${colors.bg.brand.primaryBold};
    border-left: 4px solid ${colors.bg.brand.primaryBold};
  }

  .cropper-point.point-se {
    right: -2px;
    bottom: -2px;
    border-right: 4px solid ${colors.bg.brand.primaryBold};
    border-bottom: 4px solid ${colors.bg.brand.primaryBold};
  }
`;

export const ToolGroup = styled.div`
  position: absolute;
  bottom: ${spacing["2xl"]};
  left: ${spacing["3xl"]};
  z-index: 2;
  display: flex;
  gap: ${spacing["2xl"]};
`;

export const ToolButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: ${spacing.none};
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: ${radius.xs};
  background: ${colors.bg.invert.secondarySoft};
  color: ${colors.icon.base.invert};
  cursor: pointer;

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    font-size: 24px;
    line-height: 1;
  }

  &:hover {
    background: rgba(24, 27, 37, 0.55);
  }
`;
